module.exports = __webpack_public_path__ + "img/vetores-09.53ab0fc3.png";